import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$da72 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as cloudflareRuntime$7a70 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/cloudflare.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "option": {
      "modifiers": {
        "format": "auto",
        "fit": "contain",
        "width": 180
      }
    },
    "static": {
      "format": "auto",
      "fit": "cover",
      "quality": 80
    }
  },
  "provider": "cloudflare",
  "domains": [
    "members.reverse.health",
    "members.musclecharge.app"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$da72, defaults: {} },
  ['cloudflare']: { provider: cloudflareRuntime$7a70, defaults: {"baseURL":"https://members.reverse.health"} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
